const SP_MQ = "(max-width: 768px)";
const SLICE = 40;
const BORDER = 20;

let frameImg = null;
let frameImgSrc = "";

const drawNineSlice = (ctx, img, w, h) => {
  const s = SLICE;
  const d = BORDER;
  const iw = img.naturalWidth;
  const ih = img.naturalHeight;
  const midW = iw - s * 2;
  const midH = ih - s * 2;
  const destMidW = Math.max(0, w - d * 2);
  const destMidH = Math.max(0, h - d * 2);

  ctx.clearRect(0, 0, w, h);

  ctx.drawImage(img, 0, 0, s, s, 0, 0, d, d);
  ctx.drawImage(img, iw - s, 0, s, s, w - d, 0, d, d);
  ctx.drawImage(img, 0, ih - s, s, s, 0, h - d, d, d);
  ctx.drawImage(img, iw - s, ih - s, s, s, w - d, h - d, d, d);

  ctx.drawImage(img, s, 0, midW, s, d, 0, destMidW, d);
  ctx.drawImage(img, s, ih - s, midW, s, d, h - d, destMidW, d);
  ctx.drawImage(img, 0, s, s, midH, 0, d, d, destMidH);
  ctx.drawImage(img, iw - s, s, s, midH, w - d, d, d, destMidH);
};

const ensureFrameImage = (src) => {
  if (!src) return Promise.resolve(null);
  if (frameImg && frameImgSrc === src && frameImg.complete) {
    return Promise.resolve(frameImg);
  }
  frameImgSrc = src;
  frameImg = new Image();
  frameImg.decoding = "async";
  frameImg.src = src;
  return new Promise((resolve) => {
    if (frameImg.complete) {
      resolve(frameImg);
      return;
    }
    frameImg.onload = () => resolve(frameImg);
    frameImg.onerror = () => resolve(null);
  });
};

export const paintPageFrame = () => {
  const frame = document.querySelector(".page-frame");
  const canvas = frame?.querySelector(".page-frame__canvas");
  const src = frame?.dataset.spFrame;
  if (!frame || !canvas || !src || !window.matchMedia(SP_MQ).matches) {
    return;
  }

  const cssW = frame.clientWidth;
  const cssH = frame.clientHeight;
  if (cssW < 1 || cssH < 1) return;

  ensureFrameImage(src).then((img) => {
    if (!img || !window.matchMedia(SP_MQ).matches) return;
    const dpr = window.devicePixelRatio || 1;
    canvas.width = Math.round(cssW * dpr);
    canvas.height = Math.round(cssH * dpr);
    canvas.style.width = `${cssW}px`;
    canvas.style.height = `${cssH}px`;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    drawNineSlice(ctx, img, cssW, cssH);
  });
};

export const initPageFrame = () => {
  const src = document.querySelector(".page-frame")?.dataset.spFrame;
  if (src) ensureFrameImage(src);
};
